<template>
    <div class="material-aside" :style="'height:'+treeHeight">
        <div class="material_tree" v-for="(item,index) in leftTree" :key="index">
<!--            <el-collapse>-->
                <div class="material_chapters" :class="isClickAll ? 'click_color' : ''" @click="clickTitleSearch(subjectId)">
                    <span v-if="!isClickAll">{{subjectname}}</span>
                    <span v-if="isClickAll">{{subjectname}}</span>
                </div>
                <div class="material_CTreeCtrl" >
                    <el-tree
                        :data="item.materials"
                        node-key="id"
                        default-expand-all
                        :ref="'tree'+item.id"
                        :props="defaultProps"
                        draggable
                        @node-drop="handleDrop"
                        :expand-on-click-node="false"
                        @node-click="(data,node,_this) => treeClick(data,node,_this,item)"
                    >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span v-if="data.status == 1" class="father" :title="node.label">{{ node.label }}</span>
                      <el-input
                        class="nodeInput"
                        v-if="data.status == 0"
                        style="width: 90%; margin-right: 20px;"
                        v-model="data.name"
                        size="small"
                        :ref="'edit'+data.id"
                        @blur="blurEdit(data, node)"
                        @keyup.enter.native="$event.target.blur"
                      ></el-input>
                        <!-- <span  class="child">
                          <span v-if="data.status == 1">
                            <i class="tree-icon el-icon-plus" @click.stop="() => append(node, data,item)"></i>
                          </span>
                          <span class="item" v-if="data.status == 1">
                            <i class="tree-icon el-icon-edit-outline" @click.stop="() => edit(node, data,item)"></i>
                          </span>
                          <span class="item" v-if="data.status == 1">
                            <i class="tree-icon el-icon-delete" @click.stop="() => remove(node, data,item)"></i>
                          </span>
                        </span> -->
                    </span>
                  </el-tree>
                    </div>
<!--                </el-collapse-item>-->
<!--            </el-collapse>-->
          </div>
<!--        <div slot="empty" class="empty_material" v-show="(!materialId || materialId == '') && !isTreeShow">-->
<!--          <img src="@/assets/image/sources/table_no_data.png" alt="加载失败"/>-->
<!--          <p>没有可用科目</p>-->
<!--        </div>-->
    </div>

</template>

<script>
    import * as api from '../api/sourceApi'
    import bus from "../vendor/eventbus.js";
    export default {
        name: "LeftTree",
        components: {},
        props:{
            query: {
                tyep: Object
            }
        },
        data() {
            return {
                treeHeight:window.innerHeight - 150+'px',
                //左侧目录树
                subjectname: null,
                leftTree: [],
                isTreeShow: false,
                defaultProps: {
                    label: "name"
                },
                saveType:0, //失去焦点保存类型  1 添加一级节点 2 添加子节点  3 编辑名字保存
                items: "",
                activeNames: ['1'],
                isClickAll: true,
                subjectId:"",
            };
        },

        mounted() {
            // this.treeList();
        },

        methods: {
            //左侧目录树方法
            treeList(id) {
                console.log(this.query)
                api.getMaterialTreeListById(id || this.query.subjectId,{}).then(res =>{
                    if(res.code =="0"){
                        this.subjectname = res.data.name;
                        this.leftTree=[];
                        this.leftTree.push(res.data);
                        let item = res.data;
                        let sId = res.data.id; //subjectId
                        this.subjectId=sId;
                        this.$emit("showList", "",sId,true);
                        bus.$emit('materialObj',item);
                    }

                })

            },

            treeClick(data, node,_this,item) {
                this.isClickAll = false
                console.log(data,'ab')
                let arrName = [];//父节点的名称
                let getParentNameArr = (node,arr) => {
                    if(node.parent){
                        arr.push(node.data.name);
                        getParentNameArr(node.parent,arr);
                    }
                };
                getParentNameArr(node,arrName);
                let arrId = [];//父节点的名称
                let getParentIdArr = (node,arr) => {
                    if(node.parent){
                        arr.push(node.data.id);
                        getParentIdArr(node.parent,arr);
                    }
                };
                getParentIdArr(node,arrId);
                let materialClassifyName = arrName.reverse().join(" / ");
                item.materialClassifyName = materialClassifyName;
                arrId.push(item.id);
                arrId.reverse();
                arrId.shift(); //删除数组第一个元素
                item.arrIds = arrId;
                item.materialId=data.id;
                bus.$emit('materialObj',item);
                this.$emit("showList", data.id,data.subjectId,true);
            },
            // 点击标题搜索
            clickTitleSearch(subjectId) {
                this.isClickAll = true

                // this.$emit("treeClick", []);
                this.treeList(subjectId);
            },

            //节点拖拽完成
            handleDrop(before,after,inner){
                let level = 0;
                if(inner == 'before'){
                    level = 0
                }else if(inner == 'inner'){
                    level = 1
                }else if(inner == 'after'){
                    level = 2
                }
                // 拖拽成功完成时触发的事件
                let obj = {
                    catalogId: before.data.id,
                    progessionId: before.data.subjectId,
                    level: level,
                    targetId: after.data.id
                }
                api.moveMaterialTreeNode(obj,{method:'put'}).then((rs)=>{
                    if(rs.code == 0){
                        console.log('移动成功')
                    }
                }).catch((error)=>{
                    console.log(error)
                })
            }

        }
    };
</script>

<style scoped lang="scss">
    .material_chapters {
      font-size: 16px;
      font-weight: 600;
      color: #0F0D11;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      &:hover {
          background-color: #F0F3FA;
      }
      img {
          padding-left: 10px;
          padding-right: 5px;
          vertical-align: middle;
      }
    }
    .click_color {
      font-size: 16px;
      font-weight: 600;
      color: #0F0D11;
    }
    /deep/ .el-collapse-item__header{
        width: 93%;
        height: 34px;
        border-radius:4px 4px 4px 4px;
        position: relative;
        margin-bottom: 8px;
        /*border-left: 2px solid rgba(83,151,247,1);*/
        font-size:14px;
        padding-left: 12px;
        line-height: 34px;
        p{
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            color:rgba(83,151,247,1);
            font-weight: bold;
        }
    }
    /deep/ .el-icon-arrow-right:before{
        color:rgba(83,151,247,1);
    }
    /deep/ .el-collapse{
        border-top: none;
        border-bottom:none;
    }
    /deep/ .material_tree{
        .el-tree-node__content{
            height: 32px;
            position: relative;
            .course_catalog_operation{
                display: none;
                i{
                    margin-left: 3px;
                    color: #5397F7;
                }
            }
        }
        .el-tree-node>.el-tree-node__children{
            overflow:inherit;
        }
        .el-tree-node.is-current > .el-tree-node__content {
            /*background-color: #EDF4FF;*/
            background-color: rgba(83,151,247,.8);
            border-radius: 4px;
            color: #fff;
            /*border-left: 2px solid #5397F7;*/
            .father {
                color: #FFFFFF;
            }
        }
        .el-tree-node__content:hover{
            height: 32px;
            /*background: #EDF4FF;*/
            border-radius: 4px;
            background: #F0F3FA;
            .father {
                color: #0D0D0D;
            }
        }
        .el-collapse-item__content{
            padding-bottom: 0px;
        }
    }
    /deep/ .el-tree-node__content>.el-tree-node__expand-icon{
        /*color:rgba(83,151,247,1);*/
    }
    /deep/ .tree-icon{
        color:rgba(83,151,247,1);
    }
    /deep/ .el-tree-node__expand-icon.is-leaf {
        color: transparent;
        cursor: default;
    }

    /deep/ .custom-tree-node{
        width: 100%;
    }
    .father{
        float: left;
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        color: #9498A3;
    }
    .child{
        float:right;
        padding-right:5%;
        display: none;
    }
    .custom-tree-node .child{
        display:none;
    }

    .custom-tree-node:hover .child{
        display:block;
    }
    .empty_material{
      text-align: center;
      img{
        width: 140px;
        /*height: 140px;*/
        margin-top: 80px;
      }
      p{
        font-size:14px;
        font-weight:400;
        line-height:16px;
        color:#999999;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/leftTree.vue